export default __webpack_public_path__ + "arrow-big.56398198b262d309.svg";